//# sourceMappingURL=canvas.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/vector/canvas.interface.js
// module id = 1194
// module chunks = 4